import React from 'react';
import AppPreviewModal from '@components/modal/AppPreviewModal';
import { ProductSelectedOption } from '@models/commerce';
import { DerivedScheduleData, ProductModel, QuestionOptionEditModel } from '@models/product';
import CommercePayment from './CommercePayment';

interface CommercePaymentModalProps {
  open?: boolean;
  product?: ProductModel;
  totalFee: number;
  selectedOptions?: ProductSelectedOption;
  qnaOptions?: QuestionOptionEditModel[];
  scheduleInfo?: DerivedScheduleData;
  collectQnaInPayment?: boolean;
  onChangeQnaOptions?: (options: QuestionOptionEditModel[]) => void;
  onClickBack?: () => void;
  onConfirm?: () => void;
}

export const CommercePaymentModal: React.FC<CommercePaymentModalProps> = (props) => {
  const { open, product, totalFee, selectedOptions, onConfirm, qnaOptions, scheduleInfo } = props;

  return (
    <AppPreviewModal
      title={'결제하기'}
      open={open}
      height={0}
      hideRightNaviButton
      onLeftNaviButtonClick={() => {
        props.onClickBack && props.onClickBack();
      }}>
      <CommercePayment
        open={open}
        product={product}
        totalFee={totalFee}
        selectedOptions={selectedOptions}
        qnaOptions={qnaOptions}
        scheduleInfo={scheduleInfo}
        collectQnaInPayment={props.collectQnaInPayment}
        onChangeQnaOptions={props.onChangeQnaOptions}
        onConfirm={onConfirm}
      />
    </AppPreviewModal>
  );
};
